export default "__VITE_ASSET__GTecniGW__"